import {displayModes} from '../../../services/enums/displayModes';
import Columns from './columns';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 1,
    columns: {
      stopNumber: {
        columnName: Columns.stopNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      tourStopId: {
        columnName: Columns.tourStopId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      storagePlace: {
        columnName: Columns.storagePlace.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4
      },
      lastName: {
        columnName: Columns.lastName.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      zipcode: {
        columnName: Columns.zipcode.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 7
      },
      planedDeliveryDateShipper: {
        columnName: Columns.planedDeliveryDateShipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 8
      },
      stopStatus: {
        columnName: Columns.stopStatus.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 9
      },
      estimatedDeliveryWindow: {
        columnName: Columns.estimatedDeliveryWindow.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 10
      },
      deliveryTimeWindowShipper: {
        columnName: Columns.deliveryTimeWindowShipper.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 11
      },
    }
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {
      stopNumber: {
        columnName: Columns.stopNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      tourStopId: {
        columnName: Columns.tourStopId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      storagePlace: {
        columnName: Columns.storagePlace.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4
      },
      lastName: {
        columnName: Columns.lastName.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      zipcode: {
        columnName: Columns.zipcode.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 7
      },
      planedDeliveryDateShipper: {
        columnName: Columns.planedDeliveryDateShipper.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 8
      },
      stopStatus: {
        columnName: Columns.stopStatus.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 9
      },
      estimatedDeliveryWindow: {
        columnName: Columns.estimatedDeliveryWindow.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 10
      },
      deliveryTimeWindowShipper: {
        columnName: Columns.deliveryTimeWindowShipper.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 11
      },
    }
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {}
  },
  [displayModes.shared]: {
    columns: {
      stopNumber: {
        columnName: Columns.stopNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      tourStopId: {
        columnName: Columns.tourStopId.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      storagePlace: {
        columnName: Columns.storagePlace.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 4
      },
      lastName: {
        columnName: Columns.lastName.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
      zipcode: {
        columnName: Columns.zipcode.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 7
      },
      planedDeliveryDateShipper: {
        columnName: Columns.planedDeliveryDateShipper.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 8
      },
      stopStatus: {
        columnName: Columns.stopStatus.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 9
      },
      estimatedDeliveryWindow: {
        columnName: Columns.estimatedDeliveryWindow.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 10
      },
      deliveryTimeWindowShipper: {
        columnName: Columns.deliveryTimeWindowShipper.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 11
      },
    }
  }
}

export default DefaultConfig;